import FadeIn from './FadeIn';

export default function EpkEssentials() {
  return (
    <section id="epk" data-testid="epk-section">
      <div className="section-inner">
        <FadeIn>
          <div className="section-label">05 — EPK Essentials</div>
        </FadeIn>
        <FadeIn delay={0.15}>
          <div className="epk-grid">
            <div className="epk-bio" data-testid="epk-bio">
              <div className="epk-label">Short Bio</div>
              <p className="epk-bio-text">
                Lulo Lonke is a South African DJ and producer based in Amsterdam, working across
                Afro House, Amapiano, Deep House, and Gqom. Born in Ezibeleni, Queenstown,
                and shaped by a journey through Durban, Johannesburg, Toronto, and Amsterdam, his
                sound is the product of improvisation, memory, and a lifelong self-taught immersion
                in music and technology. His sets move between the percussive and the cinematic,
                always narrative-led and rooted in the deep well of South African musical heritage.
              </p>
            </div>
            <div className="epk-block" data-testid="epk-location">
              <div className="epk-label">Based In</div>
              <div className="epk-value">
                Amsterdam, Netherlands<br />
                <span className="epk-sub">Originally from South Africa</span>
              </div>
            </div>
            <div className="epk-block" data-testid="epk-sounds">
              <div className="epk-label">Sounds Like</div>
              <div className="epk-value">
                Afro House · Amapiano<br />
                Deep House · Gqom
              </div>
            </div>
            <div className="epk-block" data-testid="epk-available">
              <div className="epk-label">Available For</div>
              <div className="epk-value">
                Club bookings · Curated events<br />
                Mixes · Collaborations
              </div>
            </div>
            {/* <div className="epk-block" data-testid="epk-based">
              <div className="epk-label">Based In</div>
              <div className="epk-value">Europe / International</div>
            </div> */}
            <div className="epk-block" data-testid="epk-contact">
              <div className="epk-label">Contact</div>
              <div className="epk-value epk-contact-value">
                <a href="mailto:lulolonke.music@gmail.com">lulolonke.music@gmail.com</a>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
